import {Entity} from '../core/entity/core.base.entity';
import {Column} from '../core/entity/core.entity.column';
import {JoinColumn} from '../core/entity/core.entity.join.column';
import {EntityTable} from '../core/entity/core.entity.table.decorator';
import {Transient} from '../core/entity/core.entity.transient';
import {EnvironmentKind} from '../enum/environment.kind';
import {FieldRelationKind} from '../enum/field.relation.kind';
import {FieldTypeKind} from '../enum/field.type.kind';
import {DbEntity} from './db.entity';
import {ModelEntity} from './model.entity';
import {SystemEntity} from './system.entity';

@EntityTable('model_db_xref', '81cf939e-baff-4c06-b4ce-7f9c05bcd8a6')
export class ModelDbXrefEntity extends Entity {

    @JoinColumn(FieldTypeKind.GUID, DbEntity, false, false, FieldRelationKind.BELONGS_TO, 'database')
    public dbId: string;

    @JoinColumn(FieldTypeKind.GUID, ModelEntity, false, false, FieldRelationKind.BELONGS_TO, 'model', 'aliasId', 'aliasId')
    public modelId: string;

    @JoinColumn(FieldTypeKind.GUID, SystemEntity, true, false, FieldRelationKind.BELONGS_TO, 'system')
    public systemId: string;

    @Column(FieldTypeKind.GUID, false, false, true)
    public aliasId: string;

    @Column(FieldTypeKind.ENUM, false)
    public environmentKind: EnvironmentKind;

    @Column(FieldTypeKind.ANY)
    public options: any;

    @Transient()
    public model: ModelEntity;

    @Transient()
    public database: DbEntity;

}
